import { injectable } from 'inversify';
import type { HubspotWindow } from '@client/feature/customer-chatbots/domain/type/hubspot-window.type';

@injectable()
export class HubspotConversationsWidgetService {
  public identifyVisitor(email: string, token: string): void {
    const windowWithHubspot = this.getWindowWithHubspot();

    windowWithHubspot.hsConversationsSettings = {
      ...(windowWithHubspot.hsConversationsSettings ?? {}),
      identificationEmail: email,
      identificationToken: token,
    };
  }

  public unIdentifyVisitor(): void {
    const windowWithHubspot = this.getWindowWithHubspot();

    if (windowWithHubspot.hsConversationsSettings) {
      delete windowWithHubspot.hsConversationsSettings.identificationEmail;
      delete windowWithHubspot.hsConversationsSettings.identificationToken;
    }
  }

  public isVisitorIdentified(): boolean {
    const windowWithHubspot = this.getWindowWithHubspot();
    return (windowWithHubspot.hsConversationsSettings?.identificationEmail?.length ?? 0) > 0;
  }

  public load(): void {
    const loadWidget = () => {
      windowWithHubspot.HubSpotConversations?.widget?.load();
      windowWithHubspot.hsConversationsOnReady = [];
    };

    const windowWithHubspot = this.getWindowWithHubspot();
    windowWithHubspot.hsConversationsOnReady = [loadWidget];

    if (windowWithHubspot.HubSpotConversations?.widget?.load) {
      loadWidget();
      return;
    }
  }

  public refresh(): void {
    const windowWithHubspot = this.getWindowWithHubspot();
    windowWithHubspot.HubSpotConversations?.widget?.refresh?.();
  }

  public clear(): void {
    const windowWithHubspot = this.getWindowWithHubspot();
    windowWithHubspot.HubSpotConversations?.clear?.({ resetWidget: true });
  }

  public remove(): void {
    const windowWithHubspot = this.getWindowWithHubspot();
    windowWithHubspot.HubSpotConversations?.widget?.remove?.();
  }

  public isLoaded(): boolean {
    const windowWithHubspot = this.getWindowWithHubspot();
    return windowWithHubspot.HubSpotConversations?.widget?.status?.()?.loaded ?? false;
  }

  private getWindowWithHubspot(): HubspotWindow {
    return window as HubspotWindow;
  }
}
